import React, { useState } from 'react';
import SectionTitle from 'components/SectionTitle/SectionTitle';
import styles from './TabsInscrito.module.scss'; // crea este archivo SCSS si no lo tienes

export interface TabsInscritoPropsI {
  tabs: {
    id: string;
    label: string;
    content: React.ReactNode;
  }[];
}

const TabsInscrito = ({ tabs }: TabsInscritoPropsI): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabHeaders}>
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${index === activeIndex ? styles.active : ''}`}
            onClick={() => setActiveIndex(index)}
            type="button"
          >
            <SectionTitle text={tab.label} />
          </button>
        ))}
      </div>
      <div className={styles.tabContent}>{tabs[activeIndex].content}</div>
    </div>
  );
};

export default TabsInscrito;
